<template >
     <kt-panel>
        <kt-panel-body>
            <form @submit.prevent="set_sms_wallet" id="settings_sms_wallet_form">
                <kt-form-section >
                    <p class="pb-3">
                        {{ $t('notification.label.sms_wallet_title') }}
                    </p>
                    <kt-row>
                        <kt-form-group class="col-12 col-sm-4 col-md-3 kt-pt15-mobile pt-md-3" >
                            <span>
                                {{ $t('notification.label.sms_count_can_be_send') + ' :' }}
                            </span>
                            <span>
                                {{ form_data.sms_count_can_send }}
                            </span>
                        </kt-form-group>
                    </kt-row>
                    <kt-row>
                        <kt-form-group class="col-12 col-sm-4 col-md-3">
                            <kt-form-label for="sms_count">
                                {{ $t('notification.label.recharge_sms_wallet') }}
                               </kt-form-label>
                               <kt-form-control
                                dir="rtl"
                                name="sms_count_can_send"
                                type="number"
                                v-model="sms_number"
                                @keyup="setRechargePrice()"
                                @change="setRechargePrice()"
                                id="sms_number"
                               >
                               </kt-form-control>
                        </kt-form-group>
                    </kt-row>
                    <kt-row lg="12" md="12" sm="12" class="pt-md-3">
                        <kt-col>
                            <span>
                                {{ '* ' + $t('notification.label.minimum_price_for_recharge') }}
                            </span>
                        </kt-col>
                    </kt-row>
                    <kt-row>
                        <kt-form-group class="col-12 col-sm-4 col-md-3 kt-pt15-mobile pt-md-3" >
                            <div class="mb-3 ml-3">
                                <span >
                                    {{ $t('notification.label.recharge_price') + ' :' }}
                                </span>
                            </div>
                            <div class="ml-3">
                                <span>
                                    {{ recharge_price_currency_format + ' ' + $t('label.rial')  }}
                                </span>
                            </div>
                            <div>
                                <kt-form-control
                                        name="recharge_price"
                                        type="number"
                                        :value="recharge_price"
                                        style="display: none"
                                        id="recharge_price"
                                >
                                </kt-form-control>
                            </div>
                        </kt-form-group>
                        <kt-form-action class="mt-4">
                            <kt-button
                                class="m-2"
                                size="md"
                                variant="success"
                                type="submit"
                                id="submit_btn_sms_wallet"
                            >
                                {{ $t('notification.label.pay') }}
                            </kt-button>
                        </kt-form-action>
                    </kt-row>
                </kt-form-section>
            </form>
       </kt-panel-body>
     </kt-panel>
</template>
<script>
import {mapGetters} from "vuex";

export default {
    name:'smsWallet',
    props: {
        set_sms_wallet: {
            default: () => {},
            type: Function
        },
         form_data: {
            default() {
                return {}
            },
            type: Object
        }
    },
    data() {
        return {
            sms_number: 0,
            recharge_price: 0,
            recharge_price_currency_format: 0
        }
    },
    computed: {
        ...mapGetters('notificationSms', [
            'getRechargePriceStatus'
        ])
    },
    methods: {
        increment() {
            this.$store.dispatch('notificationSms/increment')
        },
        setRechargePrice() {
            this.recharge_price = this.sms_number * this.form_data.sms_price
            this.recharge_price_currency_format = this.moneyFormat(this.recharge_price)
        },
        moneyFormat(price) {
            const pieces = parseFloat(price).toFixed(2).split('')
            let ii = pieces.length - 3
            while ((ii -= 3) > 0) {
                pieces.splice(ii, 0, ',')
            }
            return  pieces.join('')
        }
    },
}
</script>
<style scoped>

</style>